import React, {Component} from "react";
import "./ScrollIndicator.css";

export default class ScrollIndicator extends Component
{
	render()
	{
		return (
			<div onClick={this.props.onClick} className="scroll-btn">
				<a>
					<span className="mouse">
						<span>
						</span>
					</span>
				</a>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/ScrollIndicator/ScrollIndicator.js